import {CommonData} from '../common/data.model';
import {Account, AccountUser} from '../accounts/account.model';
import {Doctor} from '../doctor/doctor.model';
import {PhoneNumberModel} from '../../helpers/phone_number.helper';
import {Patient} from '../patients/patient.model';

export class User extends CommonData {
  name: string;
  last_name: string;
  email: string;
  phone_number: string;
  phone_number_ui: PhoneNumberModel;
  email_verified_at: string;
  phone_verified_at: string;
  password: string;
  password_confirmation: string;
  identity_document: string;
  facial_recognition_added: boolean;
  profile_photo: string;
  sex: string;
  deleted_at: string;
  access_token: string;
  doctor: Doctor;
  patient: Patient;
  accounts: Account[] = [];
  preferences: UserPreferences;

  pivot: AccountUser;

  constructor() {
    super();

    this.preferences = new UserPreferences();
  }

  static getFullName(user: User, type: string = ""): string {
    let fullName = user.name + " " + user.last_name;
    if (
      (user.doctor !== undefined && user.doctor !== null) ||
      type === "doctor"
    ) {
      // En caso que sea doctor, se pone un Dr. al comienzo
      let prefix = "Dr. ";
      if (user.sex === "F") {
        prefix = "Dra. ";
      }

      fullName = prefix + fullName;
    }

    return fullName;
  }

  static getFullNameWithDocument(user: User, type: string = ""): string {
    let fullName = User.getFullName(user);

    if (user.identity_document) {
      fullName = user.identity_document + " - " + fullName;
    }

    return fullName;
  }

  static filterIndividualAccounts(accounts: Account[]): Account[] {
    if (accounts !== undefined) {
      return accounts.filter((data) => data.account_type_id !== "patient");
    }
    return [];
  }

  public getSex(): string {
    return this.sex;
  }
}


export class UserPreferences {
  app_start_at: string;
  tours_shown: string[] = [];
}


export class UserToken extends CommonData {
  user_id: number;
  token: string;
  token_type_id: string;
  meta_data: any;
  valid_until: string;
}



export class UserStats extends CommonData {
  user_consultation_amount: number;
  next_consultation_date: string;
}


export class profileURL {
  url: string;
}
